import { keymap } from 'prosemirror-keymap';

import { toggleItalic } from '../commands';

const italicsKeymap = keymap({
	'Mod-i': toggleItalic,
});

export default italicsKeymap;
